export default {
    IMAGES_DATA_KEY: "images",
    AUDIOS_DATA_KEY: "audios",
    SPRITE_SHEETS_DATA_KEY: "spriteSheets",
    SPINE_ANIMATION_DATA_KEY: "spineAnimations",
    images: {
        uncheckedAboveBelowBase: "src/assets/images/buttons/above_below_checkbox/uncheckedBase.png",
        uncheckedAboveBelowHover: "src/assets/images/buttons/above_below_checkbox/uncheckedHover.png",
        uncheckedAboveBelowClicked: "src/assets/images/buttons/above_below_checkbox/uncheckedClicked.png",
        uncheckedAboveBelowInactive: "src/assets/images/buttons/above_below_checkbox/uncheckedInactive.png",
        checkedAboveBelowBase: "src/assets/images/buttons/above_below_checkbox/checkedBase.png",
        checkedAboveBelowHover: "src/assets/images/buttons/above_below_checkbox/checkedHover.png",
        checkedAboveBelowClicked: "src/assets/images/buttons/above_below_checkbox/checkedClicked.png",
        checkedAboveBelowInactive: "src/assets/images/buttons/above_below_checkbox/checkedInactive.png",
        betOptionBase: "src/assets/images/buttons/bet_options/base.png",
        betOptionHover: "src/assets/images/buttons/bet_options/hover.png",
        betOptionClick: "src/assets/images/buttons/bet_options/click.png",
        betOptionInActive: "src/assets/images/buttons/bet_options/inActive.png",
        rollButtonBase: "src/assets/images/buttons/roll_button/base.png",
        rollButtonHover: "src/assets/images/buttons/roll_button/hover.png",
        rollButtonClick: "src/assets/images/buttons/roll_button/click.png",
        rollButtonInActive: "src/assets/images/buttons/roll_button/inActive.png",
        menuButtonBase: "src/assets/images/buttons/menu/base.png",
        menuButtonHover: "src/assets/images/buttons/menu/hover.png",
        menuButtonClick: "src/assets/images/buttons/menu/click.png",
        infoBase: "src/assets/images/buttons/info/base.png",
        infoHover: "src/assets/images/buttons/info/hover.png",
        infoClick: "src/assets/images/buttons/info/click.png",
        volumeOffBase: "src/assets/images/buttons/volume/baseOff.png",
        volumeOffHover: "src/assets/images/buttons/volume/hoverOff.png",
        volumeOffClick: "src/assets/images/buttons/volume/clickOff.png",
        volumeOnBase: "src/assets/images/buttons/volume/baseOn.png",
        volumeOnHover: "src/assets/images/buttons/volume/hoverOn.png",
        volumeOnClick: "src/assets/images/buttons/volume/clickOn.png",
        closeInfoMenu: "src/assets/images/buttons/close/base.png",
        closeInfoMenuHover: "src/assets/images/buttons/close/hover.png",
        closeInfoMenuClick: "src/assets/images/buttons/close/click.png",
        playInfoMenu: "src/assets/images/buttons/info_play/base.png",
        playInfoMenuHover: "src/assets/images/buttons/info_play/hover.png",
        playInfoMenuClick: "src/assets/images/buttons/info_play/click.png",
        betBarButtonBase: "src/assets/images/bet_bar/button_base.png",
        betBarButtonActive: "src/assets/images/bet_bar/button_active.png",
        betBarCover: "src/assets/images/bet_bar/cover.png",
        betBarBackground: "src/assets/images/bet_bar/background.png",
        betValueBackground: "src/assets/images/bet_value_background.png",
        payoutBackground: "src/assets/images/payoutBackground.png",
        logo: "src/assets/images/logo.png",
    },
    fonts: {
        RobotoCondensedRegular: "src/assets/fonts/RobotoCondensed-Regular.ttf",
        RobotoBold: "src/assets/fonts/Roboto-Bold.ttf",
        RobotoRegular: "src/assets/fonts/Roboto-Regular.ttf",
    },
    spriteSheets: {},
    spineAnimations: {
        result: "src/assets/spineAnimations/result/result.json",
    },
    audios: {
        resultSound: "src/assets/audios/result.ogg",
        resultAndWinSound: "src/assets/audios/result_win.ogg",
        bettingBarDown: "src/assets/audios/betting_bar_down.ogg",
        bettingBarUp: "src/assets/audios/betting_bar_up.ogg",
        backgroundTheme: "src/assets/audios/Soundtrack.ogg",
        waitingSound: "src/assets/audios/waiting_sound.ogg",
        buttonClicked: "src/assets/audios/Buttons/button_standard.ogg",
        buttonRollClicked: "src/assets/audios/Buttons/button_roll.ogg",
    },
    loadingScreen: {
        images: {
            wholeGameBackground: "src/assets/images/dice_background_for_game.png",
            loadingScreenLogo: "src/assets/images/loadingScreen/logo.png",
            loadingBarBack: "src/assets/images/loadingScreen/loading_bar_back.png",
            loadingBarCover: "src/assets/images/loadingScreen/loading_bar_cover.png",
        },
    },
};



// WEBPACK FOOTER //
// ./src/app/configs/data.ts